export const categories: StemSplitterCategory[] = [
  "guitar",
  "piano",
  "drums",
  "bass",
  "vocals",
  "other",
];

export type StemSplitterCategory =
  | "guitar"
  | "piano"
  | "drums"
  | "bass"
  | "vocals"
  | "other";
